<template>
  <div :class="classObj" class="app-wrapper">
    <div
      v-if="device === 'mobile' && sidebar.opened"
      class="drawer-bg"
      @click="handleClickOutside"
    />
    <sidebar
      @setShow="setShow"
      @setIsShow="setIsShow"
      class="sidebar-container"
    />
    <div :class="{ hasTagsView: needTagsView }" class="main-container">
      <div :class="{ 'fixed-header': fixedHeader }">
        <navbar @goLogin="goLogin" />
      </div>
      <app-main />
    </div>
    <!-- <el-container>
      <el-header>
        <navbar />
      </el-header>
      <el-container>
        <el-aside width="200px"><sidebar class="sidebar-container" /></el-aside>
        <el-main><app-main /></el-main>
      </el-container>
    </el-container> -->
    <!-- 登录 -->
    <div class="dialog-item">
      <el-dialog
        :title="
          isLogin == 1
            ? ''
            : isLogin == 2
            ? '注册'
            : isLogin == 3
            ? '忘记密码'
            : ''
        "
        :visible.sync="show"
        custom-class="dialog"
        width="22%"
        :show-close="false"
        @close="close"
        center
      >
        <!-- 登录 -->
        <div class="dialog-box" v-if="isLogin == 1">
          <h3 class="title">
            <span>学生端</span>
            身份认证登录
          </h3>
          <div class="dialog-box-item">
            <el-input
              placeholder="输入登录账号"
              clearable
              prefix-icon="el-icon-user"
              v-model="login.account"
              @blur="blurLogin"
            ></el-input>
          </div>
          <div class="dialog-box-item">
            <el-input
              placeholder="输入右边的图形验证码"
              clearable
              v-model="login.img_code"
            ></el-input
            ><img @click="refresh(1)" :src="imgCode" alt="" />
          </div>
          <div class="dialog-box-item">
            <el-input
              placeholder="输入账号密码"
              clearable
              show-password
              prefix-icon="el-icon-lock"
              v-model="login.password"
            ></el-input>
          </div>
          <div class="dialog-box-item1">
            <div class="dialog-box-item-left">
              <span>还没账号？</span><span @click="isLogin = 2">去注册></span>
            </div>
            <div class="dialog-box-item-right" @click="isLogin = 3">
              忘记密码？
            </div>
          </div>
          <el-button
            type="primary"
            :loading="loading"
            @click.native.prevent="handleLogin"
            >登录</el-button
          >
          <div class="login-btn">
            <img
              @click="wxLogin"
              src="../../assets/image/logoWeixin.png"
              alt=""
            />
          </div>
        </div>
        <!-- 注册 -->
        <div class="dialog-box" v-else-if="isLogin == 2">
          <div class="dialog-box-item">
            <el-input
              placeholder="输入手机号"
              clearable
              v-model="registerForm.account"
              @blur="blurRegister"
            ></el-input>
          </div>
          <div class="dialog-box-item">
            <el-input
              placeholder="输入右边的图形验证码"
              clearable
              v-model="img_code"
            ></el-input
            ><img @click="refresh(2)" :src="imgCode" alt="" />
          </div>
          <div class="dialog-box-item">
            <el-input
              placeholder="设置账号登录密码"
              clearable
              show-password
              v-model="registerForm.password"
            ></el-input>
          </div>
          <div class="dialog-box-item">
            <el-input
              placeholder="短信验证码"
              clearable
              v-model="registerForm.code"
            ></el-input
            ><button :disabled="codeDisabled" @click="getCode(2)">
              {{ codeMsg }}
            </button>
          </div>
          <el-button type="primary" :loading="loading" @click="register"
            >注册</el-button
          >
        </div>
        <div class="dialog-box" v-else>
          <div class="dialog-box-item">
            <el-input
              placeholder="输入手机号"
              clearable
              v-model="forgetForm.account"
              @blur="blurForget"
            ></el-input>
          </div>
          <div class="dialog-box-item">
            <el-input
              placeholder="输入右边的图形验证码"
              clearable
              v-model="img_code"
            ></el-input
            ><img @click="refresh(3)" :src="imgCode" alt="" />
          </div>
          <div class="dialog-box-item">
            <el-input
              placeholder="短信验证码"
              clearable
              v-model="forgetForm.code"
            ></el-input
            ><button :disabled="codeDisabled" @click="getCode(1)">
              {{ codeMsg }}
            </button>
          </div>
          <div class="dialog-box-item">
            <el-input
              placeholder="设置账号登录密码"
              clearable
              show-password
              v-model="forgetForm.password"
            ></el-input>
          </div>
          <el-button type="primary" :loading="loading" @click="forgetPassword"
            >提交</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!-- 认证 -->
    <el-dialog
      title=""
      custom-class="dialog"
      :visible.sync="isShow"
      width="22%"
    >
      <div class="balance">
        <img
          class="rengzheng"
          src="../../assets/image/rengzhengLog.png"
          alt=""
        />
        <img
          class="rengzhengTitle"
          src="../../assets/image/rengzheng.png"
          alt=""
        />
        <div class="input">
          <el-select v-model="form.school_id" placeholder="请选择学校">
            <el-option
              v-for="item in options"
              :key="item.name"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="input">
          <el-input
            v-model="form.student_no"
            placeholder="请输入学号"
          ></el-input>
        </div>
        <div class="input">
          <el-input
            v-model="form.student_name"
            placeholder="请输入姓名"
          ></el-input>
        </div>

        <div class="recharge-btn">
          <el-button
            type="primary"
            :loading="studentBindingloading"
            @click="studentBinding"
            >确 定</el-button
          >
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="微信登录"
      :visible.sync="dialogWxLogin"
      width="30%"
      @closed="closewxLogin"
    >
      <div class="wxLoginImg">
        <img :src="wxLoginImg" alt="" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain, Settings, TagsView } from "./components";
import ResizeMixin from "./mixin/ResizeHandler";
import RightPanel from "@/components/RightPanel";
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
import request from "@/utils/request";
import { setToken } from "@/utils/auth";
import Cookies from "js-cookie";
import Utils from "@/utils/utils";
export default {
  name: "Layout",
  components: {
    Navbar,
    Sidebar,
    AppMain,
    RightPanel,
    Settings,
    TagsView,
  },
  data() {
    return {
      studentBindingloading: false,
      loading: false,
      isShow: false,
      dialogWxLogin: false,
      show: false,
      isLogin: 1,
      // 是否禁用按钮
      codeDisabled: false,
      // 倒计时秒数
      countdown: 60,
      // 按钮上的文字
      codeMsg: "获取验证码",
      // 定时器
      timer: null,
      timeWxLoginLog: null,
      imgCode: require("../../assets/image/nocode.png"),
      img_code: "",
      registerForm: {
        type: "2",
        account: "",
        password: "",
        code: "",
      },
      forgetForm: {
        account: "",
        password: "",
        code: "",
      },
      login: {
        type: "1",
        account: "",
        password: "",
        img_code: "",
      },
      options: [],
      value: "",
      form: {
        school_id: "",
        student_no: "",
        student_name: "",
      },
      isok: false,
      wxLoginImg: "",
    };
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapState({
      sidebar: (state) => state.app.sidebar,
      device: (state) => state.app.device,
      showSettings: (state) => state.settings.showSettings,
      needTagsView: (state) => state.settings.tagsView,
      fixedHeader: (state) => state.settings.fixedHeader,
    }),
    ...mapGetters(["getUserInfo"]),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile",
      };
    },
  },
  created() {
    this.school();
    // 如果未登录或者未认证则跳转到论坛
    if (
      !Cookies.get("Admin-Token") ||
      !JSON.parse(localStorage.getItem("userInfo")).student_id
    ) {
      // this.$router.replace("/forum/list");
    }
  },
  watch: {
    isLogin() {
      this.imgCode = require("../../assets/image/nocode.png");
      this.loading = false;
    },
    $route(to, from) {
      if (!Cookies.get("Admin-Token") && localStorage.getItem("userInfo")) {
        // Cookies.remove('userInfo')
        localStorage.removeItem("userInfo");
        this.$store.commit("setUserInfo", {});
        // this.$router.go(0);
      }
      this.isOkLogin(to.path);
    },
  },
  mounted() {
    console.log(
      this.$store.getters.getUserInfo.student_id,
      "this.$store.getters.getUserInfo.student_id"
    );
    var that = this;
    Utils.$on("isok", function (type, flag = true) {
      if (type == 1) {
        that.setShow(flag);
      } else {
        that.setIsShow(flag);
      }
    });
  },
  methods: {
    closewxLogin() {
      console.log("============");
      clearInterval(this.timeWxLoginLog);
      console.log(111111111);
    },
    getInfo() {
      return request({
        url: "/api/userend/user/info",
        method: "get",
        params: {},
      }).then((response) => {
        this.infos = response.data;
        localStorage.setItem("userInfo", JSON.stringify(response.data));
        this.$store.commit(
          "setUserInfo",
          JSON.parse(localStorage.getItem("userInfo"))
        );
      });
    },
    closeIsShow() {
      this.form = {
        school_id: "",
        student_no: "",
        student_name: "",
      };
    },
    close() {
      clearInterval(this.timer);
      if (this.isLogin == 1) {
        this.login = {
          type: "1",
          account: "",
          password: "",
          img_code: "",
        };
      } else if (this.isLogin == 2) {
        this.registerForm = {
          type: "2",
          account: "",
          password: "",
          code: "",
        };
      } else {
        this.forgetForm = {
          account: "",
          password: "",
          code: "",
        };
      }
      this.img_code = "";
    },
    // 获取验证码倒计时
    showTime() {
      if (!this.timer) {
        this.timer = setInterval(() => {
          if (this.countdown > 0 && this.countdown <= 60) {
            this.countdown--;
            this.codeDisabled = true;
            if (this.countdown !== 0) {
              this.codeMsg = "重新发送(" + this.countdown + ")";
            } else {
              clearInterval(this.timer);
              this.codeMsg = "获取验证码";
              this.countdown = 60;
              this.timer = null;
              this.codeDisabled = false;
            }
          }
        }, 1000);
      }
    },
    // 判断是否登录
    isOkLogin(path) {
      // console.log(this.$store.getters.getUserInfo.student_id,'this.$store.getters.getUserInfo.student_id')
      // this.isLogin=1
      // if(JSON.parse(localStorage.getItem('userInfo'))){
      //   this.getInfo()
      // }
      // if(path=='/forum/forumDetails'||path=='/forum/sendForum'||path=='/forum/userDetails'||path.indexOf('my_community')!=-1){
      //   if(!JSON.parse(localStorage.getItem('userInfo'))){
      //      this.show=true
      //   }
      // }else if(path=='/school/details'||path=='/'){
      //   if(!JSON.parse(localStorage.getItem('userInfo'))){
      //     this.show=true
      //   }else{
      //     if(!this.$store.getters.getUserInfo.student_id){
      //       this.isShow=true
      //     }
      //   }
      // }else if(path=='/match'||path=='/match/match'||path=='/match/details'||path.indexOf('my_study')!=-1||path.indexOf('my_match')!=-1){
      //   if(!JSON.parse(localStorage.getItem('userInfo'))){
      //     this.show=true
      //   }else{
      //     if(!this.$store.getters.getUserInfo.student_id){
      //       this.isShow=true
      //     }
      //   }
      // }
    },
    // 刷新图形验证码
    refresh(type) {
      if (type == 1) {
        if (!this.login.account) {
          this.$message.error("账号不能为空");
          return;
        }
        this.sendLogin();
      } else if (type == 2) {
        if (!this.registerForm.account) {
          this.$message.error("手机号码不能为空");
          return;
        }
        this.sendImgCode();
      } else {
        if (!this.forgetForm.account) {
          this.$message.error("手机号码不能为空");
          return;
        }
        this.sendForgetImgCode();
      }
    },
    setShow(flag) {
      this.show = flag;
    },
    setIsShow(flag) {
      this.isShow = flag;
    },
    blurLogin() {
      if (!this.login.account) {
        // this.$message.error("账号不能为空！")
        return;
      }
      this.sendLogin();
    },
    blurRegister() {
      if (!this.registerForm.account) {
        this.$message.error("手机号码不能为空！");
        return;
      }
      this.sendImgCode();
    },
    blurForget() {
      if (!this.forgetForm.account) {
        this.$message.error("手机号码不能为空！");
        return;
      }
      this.sendForgetImgCode();
    },

    // 认证
    studentBinding() {
      if (!this.form.school_id) {
        this.$message.error("学校不能为空");
        return;
      }
      if (!this.form.student_no) {
        this.$message.error("学号不能为空");
        return;
      }
      if (!this.form.student_name) {
        this.$message.error("姓名不能为空");
        return;
      }
      this.studentBindingloading = true;
      request({
        url: "/api/userend/user/studentBinding",
        method: "post",
        params: this.form,
      })
        .then((response) => {
          this.$message.success("认证成功");
          this.isShow = false;
          this.studentBindingloading = false;
          this.form = {
            school_id: "",
            student_no: "",
            student_name: "",
          };
          this.info();
        })
        .catch(() => {
          this.studentBindingloading = false;
        });
    },
    // 学校
    school() {
      request({
        url: "/api/userend/school/list",
        method: "get",
        params: {},
      }).then((response) => {
        this.options = response.data;
      });
    },
    // 获取验证码
    getCode(type) {
      // 验证码60秒倒计时
      this.isok = false;
      if (this.codeDisabled == false) {
        if (type == 1) {
          if (!this.forgetForm.account) {
            this.$message.error("请先输入手机号码");
            return;
          }
          if (!this.img_code) {
            this.$message.error("请先输入图形验证码");
            return;
          }
          this.forget_send_code_sms(type);
        } else {
          if (!this.registerForm.account) {
            this.$message.error("请先输入手机号码");
            return;
          }
          if (!this.img_code) {
            this.$message.error("请先输入图形验证码");
            return;
          }
          this.send_code_sms();
        }
      } else {
        this.$message.error("倒计时结束才能再次发送");
        return;
      }
    },
    //获取微信授权小程序码
    wxLogin() {
      request({
        url: "/api/userend/user/wxMiniAuthCode",
        method: "get",
        params: {},
      }).then((response) => {
        this.dialogWxLogin = true;
        this.wxLoginImg = response.data.qr_code;
        this.timeWxLoginLog = setInterval(() => {
          this.wxLoginLog(response.data.key);
        }, 1000);
      });
    },
    //获取授权日志
    wxLoginLog(key) {
      request({
        url: "/api/userend/user/getWxMiniAuthLog",
        method: "get",
        params: { key: key },
      }).then((response) => {
        if (response.data.token) {
          clearInterval(this.timeWxLoginLog);
          setToken(response.data.token);
          this.$store.commit("SET_TOKEN", response.data.token);
          this.info();
        }
      });
    },
    // 登录
    handleLogin() {
      if (!this.login.account) {
        this.$message.error("账号不能为空！");
        return;
      }
      if (!this.login.password) {
        this.$message.error("密码不能为空！");
        return;
      }
      if (!this.login.img_code) {
        this.$message.error("验证码不能为空！");
        return;
      }
      this.loading = true;
      this.$store
        .dispatch("Login", this.login)
        .then(() => {
          this.$message.success("登录成功");
          this.show = false;
          this.info();
          this.login = {
            type: "1",
            account: "",
            password: "",
            img_code: "",
          };
          this.loading = false;
        })
        .catch(() => {
          console.log("登录失败");
          this.loading = false;
          this.sendLogin();
        });
    },
    // 注册
    register() {
      if (!this.registerForm.account) {
        this.$message.error("账号不能为空");
        return;
      }
      if (!this.registerForm.password) {
        this.$message.error("密码不能为空！");
        return;
      }
      if (!this.registerForm.code) {
        this.$message.error("验证码不能为空！");
        return;
      }
      this.loading = true;
      request({
        url: "/api/userend/register",
        method: "post",
        params: this.registerForm,
      })
        .then((response) => {
          this.$message.success("注册成功");
          this.loading = false;
          this.registerForm = {
            type: "2",
            account: "",
            password: "",
            code: "",
          };
          this.img_code = "";
          this.isLogin = 1;
        })
        .catch(() => {
          console.log("注册失败");
          this.loading = false;
          this.sendImgCode();
        });
    },
    // 忘记密码
    forgetPassword() {
      if (!this.forgetForm.account) {
        this.$message.error("账号不能为空！");
        return;
      }
      if (!this.forgetForm.password) {
        this.$message.error("密码不能为空！");
        return;
      }
      if (!this.forgetForm.code) {
        this.$message.error("验证码不能为空！");
        return;
      }
      this.loading = true;
      request({
        url: "/api/userend/forgetPassword",
        method: "post",
        params: this.forgetForm,
      })
        .then((response) => {
          this.$message.success("修改成功");
          this.loading = false;
          this.forgetForm = {
            account: "",
            password: "",
            code: "",
          };
          this.img_code = "";
          this.isLogin = 1;
        })
        .catch(() => {
          console.log("注册失败");
          this.loading = false;
          this.sendForgetImgCode();
        });
    },
    // 发送注册验证码
    send_code_sms() {
      request({
        url: "/api/userend/register/send_code_sms",
        method: "post",
        params: {
          mobile_phone: this.registerForm.account,
          img_code: this.img_code,
        },
      })
        .then((response) => {
          this.showTime(); //倒计时
        })
        .catch(() => {
          console.log("发送失败");
          this.sendImgCode();
        });
    },
    // 发送忘记密码验证码
    forget_send_code_sms(type) {
      request({
        url: "/api/userend/sendCodeSms",
        method: "post",
        params: {
          account: this.forgetForm.account,
          img_code: this.img_code,
          type: type,
        },
      })
        .then((response) => {
          console.log("发送成功");
          this.showTime(); //倒计时
        })
        .catch(() => {
          console.log("发送失败");
          this.sendForgetImgCode();
        });
    },
    // 发送注册图形验证码
    sendImgCode() {
      request({
        url: "/api/common/verify/code",
        method: "get",
        params: { key: this.registerForm.account },
      }).then((response) => {
        this.imgCode = response.data;
      });
    },
    // 发送忘记密码图形验证码
    sendForgetImgCode() {
      request({
        url: "/api/common/verify/code",
        method: "get",
        params: { key: this.forgetForm.account },
      }).then((response) => {
        this.imgCode = response.data;
      });
    },
    // 发送登录图形验证码
    sendLogin() {
      request({
        url: "/api/common/verify/code",
        method: "get",
        params: { key: this.login.account },
      }).then((response) => {
        this.imgCode = response.data;
      });
    },
    // 个人信息
    info() {
      return request({
        url: "/api/userend/user/info",
        method: "get",
        params: {},
      }).then((response) => {
        localStorage.setItem("userInfo", JSON.stringify(response.data));
        // Cookies.set('userInfo', JSON.stringify(response.data), { expires: 15 })
        this.$store.commit(
          "setUserInfo",
          JSON.parse(localStorage.getItem("userInfo"))
        );
        // console.log(sessionStorage.getItem(userInfo),'userInfo')
        this.$router.go(0);
      });
    },
    // 打开登录
    goLogin() {
      this.isLogin = 1;
      this.show = true;
    },
    handleClickOutside() {
      this.$store.dispatch("CloseSideBar", { withoutAnimation: false });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss">
.title {
  font-size: 40px;
  font-weight: 400;
  color: #333333;
  margin: 0px auto 40px auto;
  text-align: center;
  font-weight: 800;
  font-family: "Times New Roman", Times, serif;
  span {
    display: block;
    font-size: 48px;
    margin-bottom: 10px;
    font-weight: 800;
  }
}
.dialog {
  border-radius: 20px;
  position: relative;
}
.wxLoginImg {
  text-align: center;
}
.balance {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .rengzheng {
    width: 249px;
    height: 156px;
    margin: 0 auto;
    position: absolute;
    top: -156px;
  }
  .rengzhengTitle {
    width: 205px;
    height: 48px;
  }
  .input {
    width: 336px;
    margin: 0 auto;
    margin-top: 30px;
    .el-input__inner {
      width: 336px;
      height: 57px;
      background: #f9fafd;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      margin: 0 auto;
      border: none;
    }
  }
  .recharge-btn {
    width: 336px;
    height: 50px;
    margin: 0 auto;
    margin-top: 30px;
    .el-button {
      width: 336px;
      height: 50px;
      margin: 0 auto;
      background: #3d7eff;
      border-radius: 6px;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
  }
}
.dialog-item {
  .dialog {
    border-radius: 20px;
  }
  .el-dialog__title {
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #1e2134;
  }
  .dialog-box {
    padding: 0 30px;
    .dialog-box-item {
      padding: 15px 0;
      border-bottom: 1px solid #f9fafd;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .el-input--prefix .el-input__inner {
        border: none;
        font-size: 16px;
      }
      .el-input__inner {
        border: none;
        font-size: 16px;
      }
      img {
        cursor: pointer;
        width: 105px;
        height: 50px;
      }
      button {
        cursor: pointer;
        background: none;
        border: none;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #1875ff;
        white-space: nowrap;
      }
    }
    .dialog-box-item1 {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 15px 0;
      .dialog-box-item-left {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        span {
          &:nth-child(1) {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
          }
          &:nth-child(2) {
            cursor: pointer;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #1875ff;
          }
        }
      }
      .dialog-box-item-right {
        cursor: pointer;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #1875ff;
      }
    }
    .el-button {
      margin-top: 20px;
      width: 100%;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
    .login-btn {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-top: 45px;
      img {
        cursor: pointer;
        width: 40px;
        height: 40px;
        margin: 0 auto;
      }
    }
  }
}
@import "src/styles/mixin.scss";
@import "src/styles/variables.scss";
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: 100%;
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}
</style>
